export default {
  methods: {
    getIconPath (routeName) {
      const isActive = this.$route.name.indexOf(routeName) === 0
      const mapping = {
        UserSaved: 'icon-heart',
        UserHistory: 'icon-order',
        UserPoints: 'icon-coupon',
        UserInfo: 'icon-user',
        UserPremium: 'icon-premium'
      }
      return require(`@/assets/images/menu/${mapping[routeName]}${isActive ? '-active' : ''}.svg`)
    }
  }
}
